import { Component, OnInit, Input} from '@angular/core';


@Component({
    selector: 'app-total-and-active-counts',
    templateUrl: './total-and-active-counts.component.html',
    standalone: false
})
export class TotalAndActiveCountsComponent implements OnInit {
  @Input() totalAndActiveCounts;
  types = {
    type: '',
    active: 0,
    total: 0
  };


  constructor() {
  }

  ngOnInit() {
    if (this.totalAndActiveCounts === undefined) {
      this.totalAndActiveCounts = this.types;
    }
  }


}
